// Pictogram van de Fotolijst (0064): klein en los, zodat het menu het kan tonen zonder de pagina.

/** Eigen pictogram (geen standaardset): een fotolijst met een heuvel en een zon. */
export function FrameGlyph({ size = 40 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
    >
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3.5 17l5-5 4 4 2.5-2.5 5.5 5" />
      <circle cx="15.5" cy="9" r="1.6" />
    </svg>
  );
}
